import React, { useEffect, useState } from "react";
import { Label, RequiredRule } from 'devextreme-react/form';
import { CheckBox, DateBox, NumberBox, TextBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";
import { function_VEN_Reservas_Cabecera_Leer } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import LV_EEX_Participante from "./LV_EEX_Participante.js";
import { Email } from "@mui/icons-material";
import { validarEMail } from "../../../../funciones/Varios.js";
import { useNavigate } from 'react-router-dom';

const LV_EEX_Responsable = (props) => {
    const navigate = useNavigate();
    const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_LeerPorDNISinPassword, function_ABM_EEX_Clientes_InsertarBasico } } = require('neftis7_apicaller');
    const [idCliente, setIdCliente] = useState(0);
    const [cuit, setCUIT] = useState(props.CUIT);
    const [nombre, setNombre] = useState("");
    const [apellido, setApellido] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState(new Date());
    const [telefono, setTelefono] = useState("");
    const [eMail, setEMail] = useState("");
    const [participante, setParticipante] = useState("");
    const [camposDeCarga, setCamposDeCarga] = useState(false);
    const [sinCampos, setSinCampos] = useState(true);
    const [cierreEnProceso, setCierreEnProceso] = useState(false);

    const handleOnClickCrearResponsable = async () => {
        const hoy = new Date();
        const unAnioAtras = new Date();
        unAnioAtras.setFullYear(hoy.getFullYear() - 1);

        if (!nombre) {
            alert("Falta el Nombre.");
            return;
        }

        if (!apellido) {
            alert("Falta el Apellido.");
            return;
        }

        if (!eMail) {
            alert("Falta el E-Mail.");
            return;
        }

        if (!validarEMail(eMail)) {
            alert("El E-Mail es inválido.");
            return;
        }
        else {
            setEMail(validarEMail(eMail))
        }

        if (!telefono) {
            alert("Falta el Teléfono.");
            return;
        }

        if (fechaNacimiento > unAnioAtras) {
            alert("La Fecha de Nacimiento es incorrecta.");
            return;
        }

        try {
            if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
            setCierreEnProceso(true);

            const resultCliente = await function_ABM_EEX_Clientes_InsertarBasico(apellido, nombre, cuit,
                await FormateoFechaPara_yyyyMMdd(fechaNacimiento), cuit, eMail, telefono)

            alert("Has registrado correctamente a " + nombre + "!.");

            const nuevoId = resultCliente.data.codigoGenerado;

            setIdCliente(nuevoId);
            setCamposDeCarga(false);
            setParticipante(`Participante: ${nombre} ${apellido}`);

        } catch (error) {
            alert(nombre + ", hubo problemas en el registro.");
        } finally {
            setCierreEnProceso(false); // Se habilita el botón de nuevo
        }
    };

    const handleOnClickCambiarEMail = async () => {
        navigate("/ReservaIntegranteCambioEMail/" + localStorage.getItem("CodigoCompania") + "/" + localStorage.getItem("CodigoEmpresa") + "/" + localStorage.getItem("CodigoPlanta") + "/" + idCliente)
    }

    useEffect(() => {
        const obtenerCliente = async () => {
            if (!cuit || cuit === "") {
                setSinCampos(true);
                return;
            }

            setSinCampos(false);
            const resultClientes = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuit);

            if (resultClientes?.data?.length > 0) {
                setCamposDeCarga(false);
                setIdCliente(resultClientes.data[0].IdCliente);
                setNombre(resultClientes.data[0].Nombre);
                setApellido(resultClientes.data[0].Apellido);
                setEMail(resultClientes.data[0].Emails);
                setTelefono(resultClientes.data[0].Telefonos);
                setFechaNacimiento(resultClientes.data[0].FechaNacimiento);

                setParticipante(`Responsable: ${resultClientes.data[0].Nombre} ${resultClientes.data[0].Apellido} - E-MAIL: ${resultClientes.data[0].Emails} - TELEFONOS: ${resultClientes.data[0].Telefonos}`);
            } else {
                setCamposDeCarga(true);
                setIdCliente(0);
                setNombre("");
                setApellido("");
                setEMail("");
                setTelefono("");
                setFechaNacimiento(new Date());
                setParticipante("");
            }
        };

        obtenerCliente();
    }, [cuit]);

    return (
        <div className="LV-GroupBox-div" style={{ width: '100%', gap: '20px' }}>
            <div className="LV-FlexContainer" style={{ width: '100%', gap: '20px' }}>
                RESPONSABLE (verificá que tú E-Mail y Teléfono sean correctos.)
            </div>
            <div className="LV-FlexContainer" style={{ width: '100%', gap: '20px' }}>
                <NumberBox value={idCliente} onValueChanged={e => setIdCliente(e.value)} visible={false} />

                <NumberBox
                    label="D.N.I."
                    value={cuit}
                    width={120}
                    visible={false}
                    onValueChanged={e => setCUIT(e.value)}>
                    <Label text="D.N.I." />
                    <RequiredRule message="Indicar el D.N.I. es obligatorio." />
                </NumberBox>

                <TextBox
                    label="Nombre"
                    value={nombre}
                    width={300}
                    onValueChanged={e => setNombre(e.value)}
                    visible={camposDeCarga && !sinCampos}>
                    <Label text="Nombre" />
                    <RequiredRule message="Indicar el Nombre es obligatorio." />
                </TextBox>

                <TextBox
                    label="Apellido"
                    value={apellido}
                    width={300}
                    onValueChanged={e => setApellido(e.value)}
                    visible={camposDeCarga && !sinCampos}>
                    <Label text="Apellido" />
                    <RequiredRule message="Indicar el Apellido es obligatorio." />
                </TextBox>

                <TextBox
                    label="Participante"
                    value={participante}
                    width={800}
                    visible={!camposDeCarga && !sinCampos}
                    readOnly={true}>
                </TextBox>

                <LVButtonAccion
                    Disabled={cierreEnProceso}
                    Texto="CAMBIAR E-MAIL" Ancho={180} onClick={handleOnClickCambiarEMail}
                    visible={!camposDeCarga && !sinCampos} />

                <span style={{ visibility: !sinCampos ? 'visible' : 'hidden', display: 'block', marginBottom: '5px' }}>
                    Fecha de Nacimiento
                </span>
                <DateBox
                    displayFormat="dd/MM/yyyy"
                    value={fechaNacimiento}
                    onValueChanged={e => setFechaNacimiento(e.value)}
                    visible={!sinCampos}
                    readOnly={!camposDeCarga}
                    width={120}
                />

                <LVButtonAccion
                    Disabled={cierreEnProceso} Texto="CREAR RESPONSABLE" Ancho={180}
                    onClick={handleOnClickCrearResponsable} visible={camposDeCarga && !sinCampos} />
            </div>
            <div className="LV-FlexContainer" style={{ width: '100%', gap: '20px' }}>
                <TextBox
                    label="Teléfono"
                    value={telefono}
                    onValueChanged={e => setTelefono(e.value)}
                    visible={camposDeCarga && !sinCampos}
                    width={400}>
                    <Label text="Teléfono" />
                    <RequiredRule message="Indicar el Teléfono es obligatorio." />
                </TextBox>

                <TextBox
                    label="E-Mail"
                    value={eMail}
                    onValueChanged={e => setEMail(e.value)}
                    visible={camposDeCarga && !sinCampos}
                    width={400}>
                    <Label text="E-Mail" />
                    <RequiredRule message="Indicar el E-Mail es obligatorio." />
                </TextBox>
            </div>
        </div>
    );
}

export default LV_EEX_Responsable;